import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, useTransform, useMotionTemplate } from "framer-motion";
import { ease } from "../../lib/scroll";

export const TiltSlab = ({ src, alt }) => {
  const [tiltable, setTiltable] = useState(false);
  useEffect(() => {
    setTiltable(window.matchMedia("(hover: hover) and (pointer: fine)").matches);
  }, []);

  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [14, -14]), { stiffness: 140, damping: 16 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-16, 16]), { stiffness: 140, damping: 16 });
  const sx = useTransform(mx, [-0.5, 0.5], [10, 90]);
  const sy = useTransform(my, [-0.5, 0.5], [10, 90]);
  const sheen = useMotionTemplate`radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,0.38), rgba(63,208,255,0.10) 30%, transparent 55%)`;

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  const frame = (
    <div className="slab-frame relative aspect-[2/3] overflow-hidden rounded-[26px]">
      <img src={src} alt={alt} className="h-full w-full object-cover" />
      {tiltable && <motion.div className="pointer-events-none absolute inset-0 mix-blend-overlay" style={{ background: sheen }} />}
      <div className="holo pointer-events-none absolute inset-0" />
    </div>
  );

  return (
    <div onPointerMove={tiltable ? onMove : undefined} onPointerLeave={tiltable ? reset : undefined} data-testid="hero-tilt-slab">
      {tiltable ? (
        <div className="[perspective:1400px]">
          <motion.div
            initial={{ rotateY: -55, rotateX: 10, opacity: 0, scale: 0.85 }}
            animate={{ rotateY: 0, rotateX: 0, opacity: 1, scale: 1 }}
            transition={{ duration: 1.6, ease, delay: 0.5 }}
          >
            <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative">
              {frame}
              <div className="absolute -bottom-5 left-1/2 h-10 w-3/4 -translate-x-1/2 rounded-full bg-bolt/40 blur-2xl" style={{ transform: "translateZ(-60px)" }} />
            </motion.div>
          </motion.div>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease, delay: 0.5 }}
          className="relative"
        >
          <motion.div animate={{ y: [0, -10, 0] }} transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}>
            {frame}
          </motion.div>
          <div className="absolute -bottom-5 left-1/2 h-10 w-3/4 -translate-x-1/2 rounded-full bg-bolt/40 blur-2xl" />
        </motion.div>
      )}
    </div>
  );
};
